<template>
    <v-card class="white border-boxGlobal" style="padding: 1rem; min-height: 60dvh;">
        <v-row class="ml-1 mr-1">
            <v-col class="tabsNH" cols="12">
                <v-col cols="12" style="display: flex; justify-content: space-between; min-height: 50px">
                    <div>
                        <v-btn small class="mx-2 btndelete" v-if="selectedRequest" @click.prevent="handleDeleteRequest" style="align-self: flex-start;">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </div>
                    <div>
                        <v-btn small class="mx-2 btn-save" @click.prevent="showRequests = true">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']" small class="mx-2 btn-process" @click.prevent="goToManageRequests" title="Gestionar solicitudes">
                            <v-icon>mdi-clipboard-check</v-icon>
                        </v-btn>
                        <v-btn small class="mx-2 btnclean" @click="handleReset">
                            <v-icon>mdi-broom</v-icon>
                        </v-btn>
                        <v-btn small class="mx-2 btn-save" v-if="dataToAdjust.length" @click.prevent="confirmFinalSubmit">
                            <v-icon>mdi-send</v-icon>
                            Enviar solicitud
                        </v-btn>
                    </div>
                </v-col>
            </v-col>
        </v-row>

        <!-- Indicador de solicitud activa reemplazando el título -->
        <div v-if="(selectedRequest && selectedRequest.ID_Request) || currentRequestId || dataToAdjust.length > 0" class="mt-6 mb-6 ml-1 mr-1">
            <v-alert
                color="info"
                text
                outlined
                icon="mdi-clipboard-list"
                class="mb-0"
            >
                <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                    <span v-if="(selectedRequest && selectedRequest.ID_Request) || currentRequestId">
                        <strong>Solicitud Activa:</strong> {{ selectedRequest?.ID_Request || currentRequestId }}
                    </span>
                    <span v-if="!(selectedRequest && selectedRequest.ID_Request) && !currentRequestId && dataToAdjust.length > 0">
                        <strong>Nueva Solicitud</strong>
                    </span>
                    <v-chip small color="blue" text-color="white">
                        Estado: {{ statusParams[selectedRequest?.Status || 0] || 'Borrador' }}
                    </v-chip>
                    <v-chip 
                        v-if="dataToAdjust.length > 0"
                        color="primary" 
                        text-color="white"
                        small
                    >
                        <v-icon left small>mdi-package-variant</v-icon>
                        {{ dataToAdjust.length }} productos en solicitud
                    </v-chip>
                    <v-chip 
                        v-if="selectedRequest && selectedRequest.Status === 0" 
                        color="orange" 
                        text-color="white"
                        small
                    >
                        <v-icon left small>mdi-content-save</v-icon>
                        Solicitud en borrador
                    </v-chip>
                </div>
            </v-alert>
        </div>

        <!-- Espaciado para compensar la eliminación del título -->
        <div class="mt-6 mb-4"></div>

        <v-row style="padding: 0 2rem; justify-content: flex-end;">
            <v-col cols="12" md="4" class="d-flex align-center justify-end">
                <v-checkbox
                    v-model="showZeroLots"
                    label="Mostrar productos con lotes en cero"
                    color="primary"
                    hide-details
                    dense
                    style="margin-top: 0;"
                ></v-checkbox>
            </v-col>
        </v-row>
    
        <v-card-actions class="mt-3" style="align-items: flex-start; position: relative;">
            <div style="display: flex; flex-direction: row; gap: 1rem; width: 100%; justify-content: space-between; align-items: flex-start;">
                <div style="display: flex; gap: 1rem; align-items: flex-start; flex: 1;">
                    <!-- Selector de bodega -->
                    <div style="width: 220px;">
                        <v-select
                            v-model="selectedWarehouse"
                            :items="warehouseOptions"
                            item-text="name"
                            item-value="value"
                            label="Almacén"
                            outlined
                            dense
                            :disabled="selectedRequest && selectedRequest.Status !== 0"
                            @change="onWarehouseChange"
                            prepend-inner-icon="mdi-warehouse"
                        ></v-select>
                    </div>
                    <!-- Buscadores lado a lado -->
                    <div style="display: flex; gap: 16px; flex: 1; align-items: flex-start;">
                        <!-- Buscador ampliado -->
                        <div style="position: relative; flex: 1; max-width: 400px;">
                            <v-text-field
                                v-model="barcodeSearch"
                                label="Buscar por código de barras, nombre o ID"
                                placeholder="Ingrese código de barras, nombre del producto o ID..."
                                outlined
                                dense
                                style="width: 100%;"
                                :disabled="selectedRequest && selectedRequest.Status !== 0"
                                :loading="searchLoading"
                                @keyup.enter="searchByBarcode"
                                @input="onSearchInput"
                                :append-icon="searchLoading ? 'mdi-loading' : 'mdi-magnify'"
                                @click:append="searchByBarcode"
                                clearable
                                @click:clear="clearBarcodeSearch"
                                hint="Presiona Enter o haz clic en la lupa para buscar"
                            ></v-text-field>
                            
                            <!-- Resultados de búsqueda por código de barras -->
                            <v-card 
                                v-if="barcodeResults.length > 0 || (barcodeSearch.length >= 3 && !searchLoading)" 
                                elevation="4" 
                                style="position: absolute; top: 100%; left: 0; width: 100%; max-height: 300px; overflow-y: auto; z-index: 1000;"
                            >
                                <v-list dense>
                                    <!-- Resultados encontrados -->
                                    <v-list-item
                                        v-for="item in barcodeResults"
                                        :key="`${item.ID_Item}-${item.Warehouse}-${item.ID_ItemBatch}`"
                                        @click="addItemFromBarcode(item)"
                                        style="cursor: pointer;"
                                        class="barcode-result-item"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-medium">{{ item.ItemName }}</v-list-item-title>
                                            <v-list-item-subtitle class="text--secondary scrollable-text">
                                                <strong>Cód:</strong> {{ item.BarCode }} | 
                                                <strong>Stock:</strong> {{ item.ItemCurrentQuantity || item.TotalStock }}
                                                <span v-if="item.ID_ItemBatch"> | <strong>Lt:</strong> {{ item.ID_ItemBatch }}</span>
                                                <span v-if="!selectedWarehouse && item.WarehouseName"> | <strong>Bodega:</strong> {{ item.WarehouseName }}</span>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-icon color="green" size="20">mdi-plus-circle</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                    
                                    <!-- Mensaje cuando no hay resultados -->
                                    <v-list-item v-if="barcodeResults.length === 0 && barcodeSearch.length >= 3 && !searchLoading">
                                        <v-list-item-content>
                                            <v-list-item-title class="text-center text--secondary">
                                                <v-icon color="grey">mdi-magnify-close</v-icon>
                                                No se encontraron productos
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </div>
                        <!-- Campo de código de barras rápido -->
                        <div style="flex: 0 0 300px;">
                            <v-text-field
                                v-model="quickBarcodeSearch"
                                label="Código Alterno Principal - Agregar directo"
                                placeholder="Escanee Código Alterno Principal..."
                                outlined
                                dense
                                style="width: 100%;"
                                :loading="quickSearchLoading"
                                @keyup.enter="addItemByQuickBarcode"
                                @input="onQuickBarcodeInput"
                                :append-icon="quickSearchLoading ? 'mdi-loading' : 'mdi-plus-circle'"
                                @click:append="addItemByQuickBarcode"
                                clearable
                                hint="Código Alterno Principal para agregar directo"
                                :disabled="selectedRequest && selectedRequest.Status !== 0"
                            ></v-text-field>
                        </div>
                        <div v-if="false" style="width: 220px;">
                            <v-autocomplete
                                v-model="selectedCategory"
                                :items="categoryOptions"
                                item-text="name"
                                item-value="value"
                                label="Categoría"
                                outlined
                                dense
                                clearable
                                :loading="filteringItemsLoading"
                                :disabled="!selectedFamily || (selectedRequest && selectedRequest.Status !== 0)"
                                @change="refreshSearchResults"
                            ></v-autocomplete>
                        </div>
                    </div>
                </div>
                
                <!-- Indicador de estado a la derecha -->
                <div v-if="(selectedRequest && selectedRequest.ID_Request) || currentRequestId" style="display: flex; align-items: center; margin-top: 8px;">
                    <v-progress-circular
                        v-if="saveStatus !== 'Guardado'"
                        indeterminate
                        color="primary"
                        size="18"
                        width="2"
                        class="mr-3"
                    ></v-progress-circular>
                    <v-icon 
                        v-else
                        color="success"
                        size="18"
                        class="mr-3"
                    >mdi-check-circle</v-icon>
                    <span class="font-weight-medium">{{ saveStatus }}</span>
                </div>
            </div>
            <!-- <v-btn @click="handleReset" class="btnclean" style="height: 30px;">Limpiar lista</v-btn> -->
        </v-card-actions>

        <v-card-actions class="pt-0" style="align-items: flex-start;">
            <div style="display: flex; flex-direction: column; gap: 0.75rem; width: 100%;">
                <div class="segment-filter-label">Agregar productos por segmentación</div>
                <div style="display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap;">
                    <div style="width: 220px;">
                        <v-autocomplete
                            v-model="draftSelectedFamily"
                            :items="familyOptions"
                            item-text="name"
                            item-value="value"
                            label="Familia"
                            outlined
                            dense
                            clearable
                            :loading="filteringItemsLoading"
                            :disabled="selectedRequest && selectedRequest.Status !== 0"
                            @change="onDraftFamilyChange"
                        ></v-autocomplete>
                    </div>
                    <div style="width: 220px;">
                        <v-autocomplete
                            v-model="draftSelectedCategory"
                            :items="draftCategoryOptions"
                            item-text="name"
                            item-value="value"
                            label="Categoría"
                            outlined
                            dense
                            clearable
                            :loading="filteringItemsLoading"
                            :disabled="!draftSelectedFamily || (selectedRequest && selectedRequest.Status !== 0)"
                        ></v-autocomplete>
                    </div>
                    <v-btn
                        class="btn-add"
                        style="height: 30px;"
                        :loading="filteringItemsLoading"
                        :disabled="selectedRequest && selectedRequest.Status !== 0"
                        @click="applySegmentFilters"
                    >
                        Aplicar
                    </v-btn>
                </div>
            </div>
        </v-card-actions>

        <v-expand-transition>
            <div v-if="filteringItemsLoading" class="mb-4 px-4">
                <div class="d-flex align-center mb-2" style="gap: 8px; color: #1976d2;">
                    <v-progress-circular indeterminate size="18" width="2" color="primary"></v-progress-circular>
                    <span class="font-weight-medium">Cargando...</span>
                </div>
                <v-progress-linear indeterminate color="primary" rounded></v-progress-linear>
            </div>
        </v-expand-transition>





        <DxDataGrid 
            v-if="!selectedRequest"
            class="isScrolledByGeneralFilter" 
            :data-source="dataToAdjust" 
            :show-borders="true"
            @exporting="onExporting"  
            @cell-value-changed="onStockAdjustmentEdit"
            @row-updated="onStockAdjustmentEdit"
            @editor-preparing="onEditorPreparing"
            :scrolling="{ useNative: true }"
            :column-auto-width="true"
        >
            <DxExport :enabled="true" />
            <DxEditing :allow-updating="true" mode="cell" />
            <DxColumn cell-template="deleteItem" caption="" :width="80"/>
            <DxColumn data-field="ID_Item" caption="ID Producto" :allow-editing="false" />
            <DxColumn data-field="BarCode" caption="Código Alterno Principal" :allow-editing="false" />
            <DxColumn data-field="ItemName" caption="Nombre Producto" :allow-editing="false" />
            <DxColumn data-field="ID_ItemBatch" caption="Lote" :allow-editing="false" />
            <!-- <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="LastPurchaseDate" caption="Última Fecha de compra" />
            <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="LastPurchasePrice" caption="Último Costo de compra" />
            <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="AverageCostFormatted" caption="Costo promedio" /> -->
            <!-- <DxColumn data-field="Providers" caption="Proveedores" :allow-editing="false" /> -->
            <DxColumn data-field="Warehouse" caption="Almacén" :allow-editing="false" cell-template="warehouseTemplate" />
            <!-- <DxColumn data-field="selectLocation" cell-template="selectLocation" caption="Ajustar Ubicación" :allow-editing="false"/>
            <DxColumn data-field="location" cell-template="location" caption="Seleccionar Ubicación" :allow-editing="false" :width="150" />
            <DxColumn data-field="familyName" caption="Familia" :allow-editing="false" />
            <DxColumn data-field="categoryName" caption="Categoria" :allow-editing="false" />
            <DxColumn data-field="subcategoryName" caption="Subcategoria" :allow-editing="false" /> -->
            <!-- <DxColumn data-field="ItemMeasureUnit" caption="Unidad" /> -->
            <!-- <DxColumn data-field="ItemMinimum" caption="Minimo" /> -->
            <!-- <DxColumn data-field="ItemMaximum" caption="Maximo" /> -->
            <DxColumn data-field="TotalStock" :width="100" caption="Existencias" :allow-editing="false" />
            <DxColumn 
                data-field="StockAdjustment" 
                :width="180" 
                caption="📝 Existencias Físicas (Editable)" 
                :allow-editing="true" 
                data-type="number"
                css-class="editable-stock-column"
                cell-template="editableStockCell"
            />
            <template #deleteItem="{ data }">
                <!-- Permitir eliminar si no hay solicitud o si está en estado borrador -->
                <a href="#" @click.prevent.stop="handleDeleteAdjustmentData(data.data)">
                    <v-icon>mdi-delete</v-icon>
                </a>
            </template>
            <template #warehouseTemplate="{ data }">
                <span>{{ getWarehouseName(data.data.Warehouse) }}</span>
            </template>
            <template #selectLocation="{ data }">
                <v-checkbox v-model="data.data.selectLocation" @change="(value) => onSelectLocationChange(value, data)" style="height: 20px; width: 20px; padding: 0; margin-inline: auto;"></v-checkbox>
            </template>
            <template #location="{ data }">
                <span v-if="!data.data.selectLocation">{{ data.data.location }}</span>
                <v-autocomplete
                    v-else
                    v-model="data.data.location_id"
                    :items="data.data.locations || []"
                    item-text="location"
                    item-value="ID_location"    
                    :disabled="!data.data.selectLocation"
                    @change="(value) => {
                        const selectedItem = data.data.locations.find(item => item.ID_location === value);
                        handleSelectLocation(selectedItem ? selectedItem.ID_location : null, selectedItem ? selectedItem.location : null, data.data);
                    }"
                    style="height: 20px; padding: 0; margin-inline: auto; margin: -5px 0px 5px;"
                ></v-autocomplete>
                <!-- <v-autocomplete
                    v-else
                    v-model="data.data.location_id"
                    :items="data.data.locations || []"
                    item-text="location"
                    item-value="ID_location"
                    :disabled="!data.data.selectLocation"
                    style="height: 20px; padding: 0; margin-inline: auto; margin: -5px 0px 5px;"
                    @change="(value) => handleLocationChange(value, data.data)" 
                    ></v-autocomplete> -->
                   
            </template>
            <template #editableStockCell="{ data }">
                <div class="editable-stock-cell-wrapper">
                    <span class="stock-value">{{ data.data.StockAdjustment || '0' }}</span>
                    <v-icon class="edit-icon" size="16" color="#9c27b0">mdi-pencil</v-icon>
                </div>
            </template>
            <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
            <DxPaging :page-size="10" />
        </DxDataGrid>
        <DxDataGrid
            v-else
            class="isScrolledByGeneralFilter" 
            :data-source="dataToAdjust" 
            :show-borders="true"
            @exporting="onExporting"  
            @cell-value-changed="onStockAdjustmentEdit"
            @row-updated="onStockAdjustmentEdit"
            @editor-preparing="onEditorPreparing"
            :scrolling="{ useNative: true }"
            :column-auto-width="true"
        >
            <DxExport :enabled="true" />
            <DxEditing :allow-updating="true" mode="cell" />
            <DxColumn cell-template="deleteItem" caption="" :width="80"/>
            <DxColumn data-field="ID_Item" caption="ID Producto" :allow-editing="false" />
            <DxColumn data-field="BarCode" caption="Código Alterno Principal" :allow-editing="false" />
            <DxColumn data-field="ItemName" caption="Nombre Producto" :allow-editing="false" />
            <DxColumn data-field="ID_ItemBatch" caption="Lote" :allow-editing="false" />
            <!-- <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="LastPurchaseDate" caption="Última Fecha de compra" />
            <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="LastPurchasePrice" caption="Último Costo de compra" />
            <DxColumn v-if="$store.getters['rolesUser/getArrayCustomRole']([242])" data-field="AverageCostFormatted" caption="Costo promedio" /> -->
            <!-- <DxColumn data-field="Providers" caption="Proveedores" :allow-editing="false" /> -->
            <DxColumn data-field="Warehouse" caption="Almacén" :allow-editing="false" cell-template="warehouseTemplate2" />
            <!-- <DxColumn data-field="selectLocation" cell-template="selectLocation" caption="Ajustar Ubicación" :allow-editing="false"/>
            <DxColumn data-field="location" cell-template="location" caption="Seleccionar Ubicación" :allow-editing="false" :width="150" />
            <DxColumn data-field="Family" caption="Familia" :allow-editing="false" />
            <DxColumn data-field="Category" caption="Categoria" :allow-editing="false" />
            <DxColumn data-field="SubCategory" caption="Subcategoria" :allow-editing="false" /> -->
            <!-- <DxColumn data-field="ItemMeasureUnit" caption="Unidad" /> -->
            <!-- <DxColumn data-field="ItemMinimum" caption="Minimo" /> -->
            <!-- <DxColumn data-field="ItemMaximum" caption="Maximo" /> -->
            <DxColumn data-field="TotalStock" :width="100" caption="Existencias" :allow-editing="false" />
            <DxColumn 
                data-field="StockAdjustment" 
                :width="180" 
                caption="📝 Existencias Físicas (Editable)" 
                :allow-editing="true" 
                data-type="number"
                css-class="editable-stock-column"
                cell-template="editableStockCell"
            />
            <template #deleteItem="{ data }">
                <!-- Permitir eliminar solo si la solicitud está en estado borrador -->
                <a v-if="selectedRequest && selectedRequest.Status === 0" href="#" @click.prevent.stop="handleDeleteAdjustmentData(data.data)">
                    <v-icon>mdi-delete</v-icon>
                </a>
            </template>
            <template #selectLocation="{ data }">
                <v-checkbox v-model="data.data.selectLocation" @change="(value) => onSelectLocationChange(value, data)" style="height: 20px; width: 20px; padding: 0; margin-inline: auto;"></v-checkbox>
            </template>
            <template #location="{ data }">
                <span v-if="!data.data.selectLocation">{{ data.data.location }}</span>
                <v-autocomplete
                    v-else
                    v-model="data.data.location_id"
                    :items="data.data.locations || []"
                    item-text="location"
                    item-value="ID_location"    
                    :disabled="!data.data.selectLocation"
                    @change="(value) => {
                        const selectedItem = data.data.locations.find(item => item.ID_location === value);
                        handleSelectLocation(selectedItem ? selectedItem.ID_location : null, selectedItem ? selectedItem.location : null, data.data);
                    }"
                    style="height: 20px; padding: 0; margin-inline: auto; margin: -5px 0px 5px;"
                ></v-autocomplete>
                <!-- <v-autocomplete
                    v-else
                    v-model="data.data.location_id"
                    :items="data.data.locations || []"
                    item-text="location"
                    item-value="ID_location"
                    :disabled="!data.data.selectLocation"
                    style="height: 20px; padding: 0; margin-inline: auto; margin: -5px 0px 5px;"
                    @change="(value) => handleLocationChange(value, data.data)" 
                    ></v-autocomplete> -->
                   
            </template>
            <template #editableStockCell="{ data }">
                <div class="editable-stock-cell-wrapper">
                    <span class="stock-value">{{ data.data.StockAdjustment || '0' }}</span>
                    <v-icon class="edit-icon" size="16" color="#9c27b0">mdi-pencil</v-icon>
                </div>
            </template>
            <template #warehouseTemplate2="{ data }">
                <span>{{ getWarehouseName(data.data.Warehouse) }}</span>
            </template>
            <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
            <DxPaging :page-size="10" />
        </DxDataGrid>

        <!-- <v-card-actions class="mt-5 mb-5">
            <v-row>
                  <v-col cols="12" class="d-flex justify-end">
                        <v-btn class="btn-save" @click.prevent="saveAdjustmentRequest" :disabled="!adjustmentDate">Guardar solicitud</v-btn>
                    </v-col>
            </v-row>
        </v-card-actions> -->

        <v-dialog v-model="showDataToAdjust" max-width="80%" scrollable>
            <v-card class="white border-boxGlobal" style="overflow-y: scroll; padding: 1rem;">
                <v-card-actions class="mt-3">
                    <v-btn v-if="selectAll" @click.prevent="handleSelectAll(false)" class="btn-save">Deseleccionar todos</v-btn>
                    <v-btn v-else @click.prevent="handleSelectAll(true)" class="btn-save">Seleccionar todos</v-btn>
                </v-card-actions>
                <VersatileFilter 
                    :columnsSearch="columsConfig" 
                    :search="search" 
                    @emptyFilter="getEarningDetail" 
                    @filtered="filterHandler" 
                    :key="Reloadfilter" 
                    :useCache="true"
                    @updateCache="updateCache" 
                    class="mx-3"
                    :oneDateFilter="true"
                    :columnfilterEndpoint="$API.inventoryReports.getInventoryFilterReportColumn"
                >
                    <DxDataGrid 
                        class="isScrolledByGeneralFilter" 
                        :data-source="inventoryData" 
                        :show-borders="true"
                        :scrolling="{ useNative: true }"
                        :column-auto-width="true"
                    >
                        <DxExport :enabled="false" />
                        <DxColumn cell-template="selectToAdjust" caption="Seleccionar" :width="80"/>
                        <DxColumn data-field="ID_Item" caption="ID Producto" />
                        <DxColumn data-field="BarCode" caption="Código Alterno Principal" />
                        <DxColumn data-field="ItemName" caption="Nombre Producto" />
                        <DxColumn data-field="ID_ItemBatch" caption="Lote" />
                        <DxColumn data-field="Providers" caption="Proveedores" />
                        <DxColumn data-field="familyName" caption="Familia" />
                        <DxColumn data-field="categoryName" caption="Categoria" />
                        <DxColumn data-field="subcategoryName" caption="Subcategoria" />
                        <DxColumn data-field="WarehouseName" caption="Almacén" />
                        <DxColumn data-field="Warehouse" caption="ID Almacén" :allow-editing="false" />
                        <DxColumn data-field="location" caption="Ubicación" />
                        <DxColumn data-field="location_id" caption="ID Ubicación" />
                        <!-- <DxColumn data-field="ItemMaximum" caption="Maximo" /> -->
                        <DxColumn data-field="TotalStock" :width="100" caption="Disponible" />
                        <template #selectToAdjust="{ data }">
                            <v-checkbox v-model="data.data.checked" @change="data.data.checked = $event" style="height: 20px; width: 20px; padding: 0; margin-inline: auto;"></v-checkbox>
                        </template>
                        <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                        <DxPaging :page-size="10" />
                    </DxDataGrid>
                </VersatileFilter>
                <v-card-actions class="mt-3">
                    <v-btn @click="showDataToAdjust = false" class="btndelete">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="btn-save" @click="addItemsToRequestAdjustment">Agregar items</v-btn>
                </v-card-actions>
            </v-card>
            <!-- <v-card class="border" style="max-height: inherit; overflow-y: auto; padding: 1rem;">
                <v-btn @click="showDataToAdjust= false" elevation="0" color="red" class="close-btn align-self-end">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <div v-if="selectedItem" style="padding: 1rem;">
                    <v-row style="margin-bottom: 1rem;">
                        <v-col cols="12" md="12">
                            <h3>Detalle de Producto</h3>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 1rem;">
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>ID Producto: </strong>
                                {{ selectedItem.ID_Item }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Nombre: </strong>
                                {{ selectedItem.ItemName }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Almacén: </strong>
                                {{ selectedItemAdjWarehouseName }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 1rem;">
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Unidad: </strong>
                                {{ selectedItem.ItemMeasureUnit }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Lote: </strong>
                                {{ selectedItem.Lote ? selectedItem.Lote : "Por defecto" }}
                            </span>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <span>
                                <strong>Último precio ingresado: </strong>
                                {{ selectedItem.LastPrice }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 1rem;">
                        <v-col cols="12" md="12">
                            <h3>Parametros de ajuste</h3>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: 1rem;">
                        <v-col cols="12" md="4">
                            <v-radio-group  v-model="adjustmentForm.add" row>
                                <v-radio label="Agregar existencia" :value="true"></v-radio>
                                <v-radio label="Restar existencia" :value="false"></v-radio>                           
                            </v-radio-group>
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-text-field v-model="adjustmentForm.quantity" label="Cantidad" outlined dense type="number" />
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-text-field v-model="getSetAverageCostAdjust" label="Costo unitario de Compra"  outlined dense />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col col="12" md="4" xl="4">
                            <v-text-field v-model="getSetLoteAdjust" label="Lote" :value="this.selectedItem.Lote"  outlined dense />
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-select v-model="getSetWarehouseAdjust" label="Almacén"
                                :items="datafilter.Warehouses" item-text="name" item-value="value"  attach
                            outlined dense />
                        </v-col>
                        <v-col col="12" md="4" xl="4">
                            <v-btn @click="showComments = !showComments" :class="adjustmentForm.comment ? 'btnclean' : 'btnblack'">
                                Comentarios
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <h2>
                                {{ "Existencias Actuales: " + stockItemAdjToShow }}
                            </h2>
                        </v-col>
                        <v-col cols="12" md="6">
                            <h2>
                                {{ "Existencias Nuevas: " + totalStockItemAdjToShow }}
                            </h2>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="mt-3">
                    <v-btn @click="showDataToAdjust = false" class="btndelete">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="btn-save" @click="addItemsToRequestAdjustment">Agregar items</v-btn>
                </v-card-actions>
            </v-card> -->
        </v-dialog>

        <v-dialog v-model="showRequests" max-width="80%" scrollable>
            <v-card class="white border-boxGlobal" style="padding: 1rem; overflow: auto;">
                <GeneralFilter 
                    :filterEndpoint="$API.inventoryReports.getFilteredAdjustmentRequest"
                    :search="search" 
                    @emptyFilter="getAdjustmentRequest" 
                    @filtered="filterRequestsHandler"
                >
                    <DxDataGrid 
                        class="isScrolledByGeneralFilter" 
                        :data-source="adjustmentRequests" 
                        :show-borders="true"
                        :scrolling="{ useNative: true }"
                        :column-auto-width="true"
                        key-expr="ID"
                    >
                        <DxExport :enabled="false" />
                        <DxColumn cell-template="selectToCheck" caption="" :width="80"/>
                        <DxColumn cell-template="manageRequest" caption="" :width="80"/>
                        <DxColumn data-field="ID_Request" caption="ID Solicitud" />
                        <DxColumn data-field="RequestDate" caption="Fecha de solicitud" />
                        <DxColumn data-field="AdjustmentDate" caption="Fecha de verificación" />
                        <DxColumn cell-template="StatusRequest" caption="Estado" />
                        <DxColumn data-field="ID_User_Request" caption="Usuario solicitante" />
                        <DxColumn data-field="ID_User_Adjust" caption="Usuario verificador" />
                        <template #selectToCheck="{ data }">
                            <a href="#" @click.prevent.stop="handleSelectRequest(data.data)" title="Ver solicitud">
                                <v-icon>mdi-eye</v-icon>
                            </a>
                        </template>
                        <template #manageRequest="{ data }">
                            <a href="#" @click.prevent.stop="handleManageRequest(data.data)" title="Gestionar solicitud">
                                <v-icon color="blue">mdi-clipboard-check</v-icon>
                            </a>
                        </template>
                        <template #StatusRequest="{ data }">
                            <p>{{ statusParams[data.data.Status] }}</p>
                        </template>
                        <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                        <DxPaging :page-size="10" />
                    </DxDataGrid>
                </GeneralFilter>
            </v-card>
        </v-dialog>

        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
        </alerts>
    </v-card>
</template>

<script>
import { DxDataGrid, DxColumn, DxExport, DxPager, DxPaging, DxEditing } from "devextreme-vue/data-grid";
import { printToExcel } from "@/helpers/printToexcel";
import VersatileFilter from "@/components/VersatileFilter";
import GeneralFilter from  "@/components/GeneralFilter";
import Alerts from "@/components/Alerts";

export default {
    name: "InventoryAdvancedReport",
    components: {
        DxDataGrid,
        DxColumn,
        DxPager,
        DxExport,
        DxPaging,
        DxEditing,
        Alerts,
        VersatileFilter,
        GeneralFilter
    },
    props: ["win", "datafilter"],
    data() {
        return {
            currentRequestId: null, // ID de la solicitud activa
            isSubmittingFinalRequest: false, // Bandera para prevenir interferencia del watcher
            previousLocationId: null,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            loading: false,
            panel: 0,
            inventoryData: [],
            inventoryDataList: [],
            adjustmentRequests: [],
            selectedRequest: null,
            start: null,
            end: null,
            summary: {
                totalUnitSales: 0,
                totalCostSales: 0,
            },
            search: {
                status: 0,
                eq: true
            },
            showFilter: false,
            filterParams: {
                ID_Item: null,
                ItemName: null,
                ItemLote: null,
                providersNames: null,
                WarehouseName: null,
                add: null,
            },
            Reloadfilter: 0,
            columsConfig: [
                {
                    name: "ID_Warehouse",
                    title: "Almacenes",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "family",
                    title: "Familia",
                    value: "",
                    type: "select",
                    options: [],
                },
                {
                    name: "category",
                    title: "Categoría",
                    value: "",
                    parent: 'family',
                    type: "select",
                    options: [],
                },
                {
                    name: "subcategory",
                    title: "Subcategoría",
                    value: "",
                    parent: 'category',
                    type: "select",
                    options: [],
                },
                {
                    name: "ID_ItemBatch",
                    title: "Lote",
                    value: "",
                    type: "select",
                    options: [],
                },
            ],
            cacheData: [],
            selectAll: false,
            selectedItem: null,
            adjustmentDate: new Date().toLocaleDateString('es-ES'), // Fecha actual en formato DD/MM/YYYY
            adjustmentForm: {},
            dataToAdjust: [],
            showComments: false,
            showDataToAdjust: false,
            showRequests: false,
            warehouses: [],
            selectedWarehouse: null,
            entryKey: null,
            statusParams: ['PENDIENTE' , 'ENVIADO' , 'PROCESADO' , 'PROCESADO PARCIAL'],
            showLocations: false,
            barcodeSearch: '',
            barcodeResults: [],
            searchTimeout: null,
            searchLoading: false,
            selectedFamily: null,
            selectedCategory: null,
            draftSelectedFamily: null,
            draftSelectedCategory: null,
            saveTimeout: null, // Para debounce del guardado automático
            showZeroLots: false, // Controla si mostrar productos con lotes en cero
            saveStatus: 'Guardado', // Estados: 'Guardado', 'Guardando...', 'Cargando...', 'Enviando...'
            quickBarcodeSearch: '', // Campo para búsqueda rápida por código de barras
            quickSearchLoading: false, // Loading para búsqueda rápida
            quickSearchTimeout: null, // Timeout para búsqueda rápida
            filterRequestSequence: 0,
            filteringItemsLoading: false,
        };
    },
    computed: {
        warehouseOptions() {
            // Usar warehouses locales si están disponibles, sino usar datafilter
            const warehousesList = this.warehouses.length > 0 ? this.warehouses : (this.datafilter.Warehouses || []);
            return warehousesList;
        },
        familyOptions() {
            return this.datafilter?.Families || [];
        },
        categoryOptions() {
            if (!this.selectedFamily) {
                return [];
            }

            return (this.datafilter?.Categories || []).filter(
                (category) => category.parent_id == this.selectedFamily
            );
        },
        draftCategoryOptions() {
            if (!this.draftSelectedFamily) {
                return [];
            }

            return (this.datafilter?.Categories || []).filter(
                (category) => category.parent_id == this.draftSelectedFamily
            );
        },
        selectedFamilyName() {
            return this.familyOptions.find((family) => family.value == this.selectedFamily)?.name || null;
        },
        selectedCategoryName() {
            return this.categoryOptions.find((category) => category.value == this.selectedCategory)?.name || null;
        },
        selectedItemAdjWarehouseName() {
            if ( this.adjustmentForm.warehouse && !this.selectedItem.WarehouseName ) {
                return this.datafilter.Warehouses.find( current => {
                    const { value: ID_Warehouse } = current;
                    return ID_Warehouse === this.adjustmentForm.warehouse;
                } ).name;
            } else {
                return this.selectedItem.WarehouseName
            } 
        },
        totalStockItemAdjToShow() {
            if (this.selectedItem.TotalStock && this.adjustmentForm.quantity && !this.adjustmentForm.add) {
                return this.selectedItem.TotalStock - this.adjustmentForm.quantity;
            } else if (this.selectedItem.TotalStock && this.adjustmentForm.quantity && this.adjustmentForm.add) {
                return this.selectedItem.TotalStock + this.adjustmentForm.quantity;
            } else if (this.selectedItem.TotalStock) {
                return this.selectedItem.TotalStock;
            }
            else if((this.selectedItem.TotalStock == null || this.selectedItem.TotalStock == undefined || this.selectedItem.TotalStock == 0 ) && this.adjustmentForm.quantity  ) 
            {
                return this.adjustmentForm.add ? this.adjustmentForm.quantity : -this.adjustmentForm.quantity;
            } 
            return 0;
        },
        getSetLoteAdjust: {
            get () {        
                return this.selectedItem.ID_ItemBatch
            },
            set (val) {
                if (val === "" || val === null || val === undefined) {
                    this.adjustmentForm.lote = this.selectedItem.ID_ItemBatch
                } else {
                    this.adjustmentForm.lote = val
                }   
            }
        },
        getSetAverageCostAdjust: {
            get () {
                return this.selectedItem.AverageCost
            },
            set (val) {
                this.adjustmentForm.price = val
            }
        },
        getSetWarehouseAdjust: {
            get () {        
                return this.selectedItem.Warehouse
            },
            set (val) {
                if (val=="") {
                    this.adjustmentForm.warehouse = this.selectedItem.Warehouse
                } else {
                    this.adjustmentForm.warehouse = val
                }
            }
        },
        stockItemAdjToShow() {
            return this.selectedItem.TotalStock ? this.selectedItem.TotalStock : 0;
        },
    },
    watch: {
        barcodeSearch(newValue) {
            if (!newValue || newValue.trim() === '') {
                this.barcodeResults = [];
            }
        },
        showZeroLots() {
            this.syncFilteredItemsToAdjust();
        },
        dataToAdjust: {
            deep: true,
            handler(newValue) {
                console.log('dataToAdjust cambió:', newValue);
                
                // No ejecutar si se está enviando la solicitud final
                if (this.isSubmittingFinalRequest) {
                    console.log('Saltando watcher porque se está enviando solicitud final');
                    return;
                }
                
                // Verificar si algún item tiene StockAdjustment modificado
                if (newValue && newValue.length > 0) {
                    const hasStockAdjustment = newValue.some(item => 
                        item.StockAdjustment !== '' && 
                        item.StockAdjustment !== null && 
                        item.StockAdjustment !== undefined
                    );
                    
                    console.log('Tiene StockAdjustment:', hasStockAdjustment);
                    
                    if (hasStockAdjustment && !this.selectedRequest && !this.currentRequestId) {
                        console.log('Creando borrador desde watcher...');
                        this.createDraftRequest();
                    } else if (hasStockAdjustment && (this.selectedRequest || this.currentRequestId)) {
                        console.log('Actualizando borrador desde watcher...');
                        // Usar debounce para evitar muchas llamadas seguidas
                        clearTimeout(this.saveTimeout);
                        // Solo mostrar estado si hay solicitud activa
                        if ((this.selectedRequest && this.selectedRequest.ID_Request) || this.currentRequestId) {
                            this.saveStatus = 'Guardando cambios...';
                        }
                        this.saveTimeout = setTimeout(() => {
                            this.updateDraftRequest();
                        }, 1000);
                    }
                }
            }
        },
        datafilter: {
            deep: true,
            handler(newValue) {
                if (newValue && newValue.Warehouses && newValue.Warehouses.length > 0) {
                    // Actualizar las bodegas locales si no se han cargado o están vacías
                    if (this.warehouses.length === 0) {
                        this.warehouses = [...newValue.Warehouses];
                        console.log('Bodegas actualizadas desde datafilter:', this.warehouses);
                    }
                }
            }
        }
        /* selectAll: {
            deep: true,
            immediate: true,
            handler(newValue) {
                console.log(newValue);
                
                if(newValue === true) {
                    for (const item of this.inventoryData) {
                        item.checked = true;
                    }
                    return;
                }
                else {
                    return this.inventoryData.forEach(item => item.checked = false);
                }                
            }
        } */
    },
    methods: {
        // Método auxiliar para manejar el estado de carga y guardado
        setLoadingState(isLoading, statusText = null) {
            this.loading = isLoading;
            // Solo cambiar el estado de guardado si hay una solicitud activa
            if ((this.selectedRequest && this.selectedRequest.ID_Request) || this.currentRequestId) {
                if (statusText) {
                    this.saveStatus = statusText;
                } else if (!isLoading) {
                    this.saveStatus = 'Guardado';
                }
            }
        },
        verifyR() {
            if (!this.selectedItem) {
                this.showAlert("warning", "Ajuste de inventario", "Seleccione un producto");
                return;
            }
            this.showDataToAdjust = true;
        },
        closeAlert() {
            this.alert.show = false;

            if (this.alert.options == "reload") {
                this.getEarningDetail();
            }
            else if (this.alert.options == "reloadData") {
                this.reloadData();
            }
        },
        acceptAlert() {
            this.alert.show = false;
            
            if (this.alert.options === "finalSubmit") {
                this.saveAdjustmentRequest(1);
            } else if (this.alert.options && this.alert.options.action === "finalSubmitWithFilteredItems") {
                this.dataToAdjust = this.dataToAdjust.filter(item => this.hasValidStockAdjustment(item));
                this.saveAdjustmentRequest(1);
            } else if (this.alert.options && this.alert.options.action === "deleteLastItem") {
                // Ejecutar eliminación del último item
                this.executeDeleteItem(this.alert.options.item);
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        reloadData(){
            this.getEarningDetail();
            this.getAdjustmentRequest();
            // Solo limpiar dataToAdjust si no hay solicitud activa
            if (!this.currentRequestId) {
                this.dataToAdjust = [];
            }
        },
        async addItemsToRequestAdjustment() {
            let itemsAdded = false;
            for (const item of this.inventoryData) {
                if(item.checked) {
                    const duplicatedItem = this.dataToAdjust.find((el) => el.ID_Item == item.ID_Item && el.ID_ItemBatch == item.ID_ItemBatch && el.BarCode == item.BarCode && el.Warehouse == item.Warehouse);

                    if(!duplicatedItem) {
                        item.stockAdjustment = '';
                        item.selectLocation = false;
                        
                        // Asegurar que TotalStock tenga el valor correcto de existencias actuales
                        if (item.ItemCurrentQuantity !== undefined && item.ItemCurrentQuantity !== null) {
                            item.TotalStock = item.ItemCurrentQuantity;
                        }
                        
                        // Asegurar la consistencia de todos los datos (bodega y lote)
                        this.ensureItemData(item);
                        
                        this.dataToAdjust.push(item);
                        itemsAdded = true;
                    }
                }
            }
            
            // Si se agregaron items y hay una solicitud activa (borrador), actualizar automáticamente
            if (itemsAdded && (this.selectedRequest || this.currentRequestId)) {
                console.log('Actualizando borrador después de agregar items desde diálogo...');
                await this.updateDraftRequest();
            }
            
            this.showDataToAdjust = false;        
        },
        handleSelectAll(value) {
            this.selectAll = value;

            if(this.selectAll === true) {
                for (const item of this.inventoryData) {
                    item.checked = true;
                }
                return;
            }
            else {
                for (const item of this.inventoryData) {
                    item.checked = false;
                }
                return;
            }
        },
        handleSelectorItem(e) {
            this.entryKey = e;
            const item = this.inventoryData.find((el) => el.ID_Item == e);
            if(item) {
                item.checked = true;
                item.selectLocation = false;
                item.stockAdjustment = '';
                
                // Asegurar la consistencia de todos los datos (bodega y lote)
                this.ensureItemData(item);
                
                this.dataToAdjust.push(item);
            }
        },
        handleSelectRequest(data) {            
            this.selectedRequest = data;
            data.AdjustmentRequestDetail.forEach(item => {
                item.isSaved = true;
                // Asegurar la consistencia de todos los datos (bodega y lote)
                this.ensureItemData(item);
            });            
            this.dataToAdjust = data.AdjustmentRequestDetail;
            this.showRequests = false;        
        },
        goToManageRequests() {
            // Emit event to parent component to switch to verification tab
            this.$emit('switchToVerificationTab');
        },
        handleManageRequest(data) {
            // Close the dialog first
            this.showRequests = false;
            
            // Store the selected request data to pass to verification component
            this.$emit('switchToVerificationTab', data);
        },
        async handleDeleteAdjustmentData(item) {
            // Verificar si es el último elemento
            if (this.dataToAdjust.length === 1) {
                const requestId = this.selectedRequest?.ID_Request || this.currentRequestId;
                
                if (requestId) {
                    // Si hay una solicitud guardada, confirmar borrado de toda la solicitud
                    this.showAlert("question2", "Eliminar solicitud", 
                        "Este es el último producto de la solicitud. ¿Está seguro que desea eliminar toda la solicitud?", 
                        { action: "deleteLastItem", item: item });
                    return;
                } else {
                    // Si no hay solicitud guardada, solo confirmar
                    this.showAlert("question2", "Eliminar producto", 
                        "¿Está seguro que desea eliminar este producto? Se limpiará toda la lista.", 
                        { action: "deleteLastItem", item: item });
                    return;
                }
            }
            
            // Si no es el último elemento, proceder normalmente
            await this.executeDeleteItem(item);
        },
        
        async executeDeleteItem(item) {
            const itemKeyToDelete = this.getAdjustmentItemKey(item);
            const newArray = this.dataToAdjust.filter(
                (el) => this.getAdjustmentItemKey(el) !== itemKeyToDelete
            );
             
            this.dataToAdjust = newArray;
            
            // Actualizar la solicitud en la base de datos si hay una solicitud activa
            const requestId = this.selectedRequest?.ID_Request || this.currentRequestId;
            if (requestId) {
                if (this.dataToAdjust.length === 0) {
                    // Si no quedan items, eliminar toda la solicitud
                    await this.deleteEntireRequest();
                } else {
                    // Si quedan items, actualizar la solicitud
                    await this.updateDraftRequest();
                }
            }
        },
        
        async deleteEntireRequest() {
            const requestId = this.selectedRequest?.ID_Request || this.currentRequestId;
            if (!requestId) return;
            
            this.setLoadingState(true, 'Eliminando solicitud...');
            
            try {
                await this.$API.inventoryReports.deleteRequestInventoryAdjustment({ 
                    ID_Request: requestId,
                    ID: this.selectedRequest?.ID || null 
                });
                
                // Limpiar estado local
                this.selectedRequest = null;
                this.currentRequestId = null;
                this.dataToAdjust = [];
                
                this.setLoadingState(false);
                this.showAlert("success", "Solicitud eliminada", "La solicitud ha sido eliminada completamente.");
                
            } catch (error) {
                console.log(error);
                this.setLoadingState(false);
                this.showAlert("warning", "Error", "No se pudo eliminar la solicitud.");
            }
        },
        async saveAdjustmentRequest(value) {
            if(!this.dataToAdjust.length){
                return this.showAlert("warning", "Advertencia", "No existen items para solicitar ajustes.");
            }

            // Si value es null, es un guardado como borrador (botón guardar)
            // Si value es 1, es envío definitivo (botón enviar solicitud)
            const isDraftSave = value === null;
            const isFinalSubmit = value === 1;

            // Activar bandera si es envío final para prevenir interferencia del watcher
            if (isFinalSubmit) {
                this.isSubmittingFinalRequest = true;
                console.log('Activando bandera de envío final');
            }

            this.loading = true;
            this.saveStatus = isDraftSave ? 'Guardando...' : 'Enviando...';

            this.dataToAdjust.forEach(item => {
                // Asegurar la consistencia de todos los datos antes del envío
                this.ensureItemData(item);
                
                // Debug: Verificar que se están enviando los campos correctos
                console.log('Datos del item a enviar:', {
                    ID_Item: item.ID_Item,
                    Warehouse: item.Warehouse,
                    WarehouseName: item.WarehouseName,
                    ID_ItemBatch: item.ID_ItemBatch,
                    BarCode: item.BarCode,
                    PrincipalBarCode: item.PrincipalBarCode,
                    StockAdjustment: item.StockAdjustment
                });
                
                item.StockAdjustment = parseFloat(item.StockAdjustment);

                // Validar que LastPurchasePrice existe y no es null/undefined antes de procesarlo
                if(item.LastPurchasePrice != null && item.LastPurchasePrice !== undefined) {
                    if(isNaN(item.LastPurchasePrice)) {
                        // Convertir a string para verificar si empieza con '$'
                        const priceStr = String(item.LastPurchasePrice);
                        if(priceStr.length > 0 && priceStr[0] == '$') {
                            item.LastPurchasePrice = parseFloat(priceStr.slice(1));
                        }
                        else {
                            item.LastPurchasePrice = parseFloat(priceStr);
                        }
                    }
                }
            });

            // Verificar si existe una solicitud activa (selectedRequest o currentRequestId)
            const hasActiveRequest = this.selectedRequest || this.currentRequestId;
            const requestId = this.selectedRequest?.ID_Request || this.currentRequestId;

            if(hasActiveRequest && requestId) {
                // Si ya existe una solicitud (modo actualización)
                // Para borradores y envío final, usar el método de reemplazo completo
                const adjustmentRequest = {
                    ID_Request: requestId,
                    replaceAllData: true, // Usar reemplazo completo
                    data: this.dataToAdjust, // Todos los datos actuales
                    status: isFinalSubmit ? 1 : (isDraftSave ? 0 : null), // 1=enviado, 0=borrador, null=mantener
                    user: JSON.parse(localStorage.getItem('user')).id,
                }

                console.log('Enviando solicitud de actualización:', {
                    ID_Request: requestId,
                    replaceAllData: true,
                    status: adjustmentRequest.status,
                    isFinalSubmit,
                    isDraftSave,
                    dataLength: this.dataToAdjust.length
                });

                await this.$API.inventoryReports.updateRequestInventoryAdjustment(adjustmentRequest)
                    .then((response) => {
                        this.loading = false;
                        this.saveStatus = 'Guardado';
                        // Desactivar bandera de envío final
                        this.isSubmittingFinalRequest = false;
                        
                        // Actualizar el estado local
                        if (this.selectedRequest) {
                            this.selectedRequest.Status = isFinalSubmit ? 1 : 0;
                        } else if (this.currentRequestId) {
                            this.selectedRequest = {
                                ID_Request: this.currentRequestId,
                                Status: isFinalSubmit ? 1 : 0
                            };
                        }
                        
                        if(isFinalSubmit) {
                            this.showAlert("success", "Existencias Avanzadas", response.message, "reloadData");
                        } else {
                            this.showAlert("success", "Existencias Avanzadas", response.message);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loading = false;
                        // Desactivar bandera de envío final también en caso de error
                        this.isSubmittingFinalRequest = false;
                        this.showAlert("warning", "Existencias Avanzadas", "Ocurrio un error al enviar la solicitud.");
                    });
            }
            else {
                // Nueva solicitud - usar endpoint de borrador si es guardado, normal si es envío
                const adjustmentRequest = {
                    date: this.adjustmentDate,
                    data: this.dataToAdjust,
                    user: JSON.parse(localStorage.getItem('user')).id,
                    status: value || 0
                }

                const apiMethod = isDraftSave ? 
                    this.$API.inventoryReports.createDraftRequestInventoryAdjustment : 
                    this.$API.inventoryReports.requestInventoryAdjustment;
    
                await apiMethod(adjustmentRequest)
                    .then((response) => {
                        this.loading = false;
                        this.saveStatus = 'Guardado';
                        // Desactivar bandera de envío final
                        this.isSubmittingFinalRequest = false;
                        
                        // Si es un borrador creado, establecer la solicitud actual con el ID recibido
                        if(isDraftSave && response.data && response.data.ID_Request) {
                            this.selectedRequest = {
                                ID_Request: response.data.ID_Request,
                                Status: 0
                            };
                            // Marcar todos los items como guardados
                            this.dataToAdjust.forEach(item => item.isSaved = true);
                        }
                        
                        if(isFinalSubmit) {
                            this.showAlert("success", "Existencias Avanzadas", response.message, "reloadData");
                        } else {
                            this.showAlert("success", "Existencias Avanzadas", response.message);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loading = false;
                        // Desactivar bandera de envío final también en caso de error
                        this.isSubmittingFinalRequest = false;
                        this.showAlert("warning", "Existencias Avanzadas", "Ocurrio un error al enviar la solicitud.");
                    });
            }
        },
        updateCache(data) {
            this.cacheData = data;
        },
        selectionChanged(e) {
            var selectedRows = e.selectedRowsData;
            if (selectedRows.length > 0) {
                this.selectedItem = selectedRows[0];
            }
        },
        getAdjustmentRequest() {
            this.setLoadingState(true, 'Cargando solicitudes...');
            this.$API.inventoryReports.getAllAdjustmentRequest({ status: 0 , eq: true })
                .then((response) => {
                    this.adjustmentRequests = response.detail;
                    this.selectedRequest = null;
                    this.setLoadingState(false);
                })
                .catch((error) => {
                    console.log(error);
                    this.setLoadingState(false);
                });
        },
        getEarningDetail() {
            this.setLoadingState(true, 'Cargando datos...');
            this.$API.inventoryReports
                .getInventoryReport()
                .then((response) => { 
                    this.inventoryData = response;
                    this.inventoryDataList = response.slice(0, 100);
                    this.selectedItem = null;
                    this.syncFilteredItemsToAdjust();
                    this.setLoadingState(false);
                })
                .catch((error) => {
                    this.setLoadingState(false);
                    console.log(error);
                });
        },
        onExporting(e) {
            printToExcel(e, "Plantilla de existencias avanzadas (Informe Físico Mejorado)");
        },
        filterHandler(response) {
            this.inventoryData = response;
        },
        filterListHandler(response) {
            this.inventoryDataList = response;
        },
        filterRequestsHandler(response) {
            this.adjustmentRequests = response.detail;
        },
        cleanFilter() {
            this.filterParams = {
                ID_Item: null,
                ItemName: null,
                ItemLote: null,
                providersNames: null,
                WarehouseName: null,
            };
            this.getEarningDetail();
        },
        getFilterEarningDetail() {
            this.loading = true;
            this.$API.inventoryReports
                .getInventoryFilterReport(this.filterParams)
                .then((response) => {
                    this.loading = false;
                    this.inventoryData = response;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        handleDeleteRequest() {
            this.loading = true;
            this.$API.inventoryReports.deleteRequestInventoryAdjustment({ ID_Request: this.selectedRequest.ID_Request , ID: this.selectedRequest.ID })
                .then((response) => {
                    this.loading = false;
                    this.showAlert("success", "Existencias Avanzadas", response.message, "reloadData");
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                    this.showAlert("warning", "Existencias Avanzadas", "Ocurrio un error al eliminar la solicitud.");
                });
        },
        assignParams() {
            if (this.datafilter) {
                this.columsConfig[0].options = this.datafilter.Warehouses;
                this.columsConfig[1].options = this.datafilter.Families;
                this.columsConfig[2].options = this.datafilter.Categories;
                this.columsConfig[3].options = this.datafilter.SubCategories;
                this.columsConfig[4].options = this.datafilter.batches;
                this.Reloadfilter += 1;
            }
        },
        async loadWarehouses() {
            try {
                const { businessid = "", branch = "" } = JSON.parse(localStorage.getItem("user"));
                const filtersWh = { business: businessid, branch, notShowReserve: 1 };
                
                const warehousesData = await this.$API.warehouse.getWarehouses(filtersWh);
                this.warehouses = warehousesData.map((wh) => ({
                    name: wh.Warehouse, 
                    value: wh.ID_Warehouse
                }));
                
                // Establecer la primera bodega como seleccionada por defecto
                if (this.warehouses.length > 0 && this.selectedWarehouse === null) {
                    this.selectedWarehouse = this.warehouses[0].value;
                }
                
                console.log('Bodegas cargadas:', this.warehouses);
                console.log('Bodega seleccionada por defecto:', this.selectedWarehouse);
            } catch (error) {
                console.error("Error al cargar bodegas:", error);
                // Fallback: usar las bodegas del datafilter si están disponibles
                if (this.datafilter && this.datafilter.Warehouses) {
                    this.warehouses = [...this.datafilter.Warehouses];
                    // Establecer la primera bodega como seleccionada por defecto también en el fallback
                    if (this.warehouses.length > 0 && this.selectedWarehouse === null) {
                        this.selectedWarehouse = this.warehouses[0].value;
                    }
                }
            }
        },
        getWarehouseName(warehouseId) {
            // Si warehouseId es null, undefined o vacío, usar la bodega seleccionada
            if (warehouseId === null || warehouseId === undefined || warehouseId === '') {
                warehouseId = this.selectedWarehouse;
            }
            
            // Buscar en warehouses locales primero
            if (this.warehouses && this.warehouses.length > 0) {
                const warehouse = this.warehouses.find(wh => wh.value === warehouseId);
                if (warehouse) return warehouse.name;
            }
            
            // Fallback: buscar en datafilter.Warehouses
            if (this.datafilter && this.datafilter.Warehouses) {
                const warehouse = this.datafilter.Warehouses.find(wh => wh.value === warehouseId);
                if (warehouse) return warehouse.name;
            }
            
            // Si no se encuentra, mostrar el ID o un mensaje por defecto
            return warehouseId ? `${warehouseId}` : 'Bodega no definida';
        },
        
        // Método auxiliar para asegurar la consistencia de los datos de bodega
        ensureWarehouseData(item) {
            // Si el item no tiene warehouse definido o es inválido, asignar la bodega seleccionada
            if (!item.Warehouse || item.Warehouse === null || item.Warehouse === undefined || item.Warehouse === '') {
                item.Warehouse = this.selectedWarehouse;
            }
            
            // Verificar si Warehouse contiene un nombre en lugar de un ID (buscar espacios o caracteres no numéricos)
            if (typeof item.Warehouse === 'string' && item.Warehouse.includes(' ')) {
                // Si Warehouse contiene espacios, probablemente es un nombre, buscar el ID correspondiente
                const warehouseData = this.findWarehouseByName(item.Warehouse);
                if (warehouseData) {
                    item.Warehouse = warehouseData.value; // Asignar el ID
                    item.WarehouseName = warehouseData.name; // Asignar el nombre
                }
            } else {
                // Si Warehouse parece ser un ID válido, asegurar que tenga el nombre correspondiente
                if (!item.WarehouseName) {
                    item.WarehouseName = this.getWarehouseName(item.Warehouse);
                }
            }
            
            return item;
        },
        
        // Método auxiliar para buscar bodega por nombre
        findWarehouseByName(warehouseName) {
            // Buscar en warehouses locales primero
            if (this.warehouses && this.warehouses.length > 0) {
                const warehouse = this.warehouses.find(wh => wh.name === warehouseName);
                if (warehouse) return warehouse;
            }
            
            // Fallback: buscar en datafilter.Warehouses
            if (this.datafilter && this.datafilter.Warehouses) {
                const warehouse = this.datafilter.Warehouses.find(wh => wh.name === warehouseName);
                if (warehouse) return warehouse;
            }
            
            return null;
        },
        
        // Método auxiliar para asegurar la consistencia de los datos del lote/batch
        ensureBatchData(item) {
            // Asegurar que ID_ItemBatch mantenga su valor original (puede ser null, string o number)
            // Solo nos aseguramos de que no sea undefined
            if (item.ID_ItemBatch === undefined) {
                item.ID_ItemBatch = null;
            }
            
            // Verificar si hay otros campos relacionados con lote que podrían estar mezclados
            // Por ejemplo, si existe un campo "Lote" que contenga el nombre en lugar del ID
            if (item.Lote && !item.ID_ItemBatch) {
                // Si hay un campo Lote pero no ID_ItemBatch, mantener ambos
                // pero asegurar que ID_ItemBatch tenga prioridad
                console.warn('Item tiene campo Lote pero no ID_ItemBatch:', item);
            }
            
            // Asegurar que siempre tengamos el campo ID_ItemBatch definido 
            // (aunque sea null para items sin lote)
            if (!Object.prototype.hasOwnProperty.call(item, 'ID_ItemBatch')) {
                item.ID_ItemBatch = null;
            }
            
            return item;
        },
        
        // Método auxiliar para asegurar la consistencia de los datos del código de barras
        ensureBarcodeData(item) {
            // Si existe BarCode, asegurar que también esté como PrincipalBarCode
            if (item.BarCode && !item.PrincipalBarCode) {
                item.PrincipalBarCode = item.BarCode;
            }
            
            // Si existe PrincipalBarCode pero no BarCode, mantener ambos
            if (item.PrincipalBarCode && !item.BarCode) {
                item.BarCode = item.PrincipalBarCode;
            }
            
            return item;
        },
        
        // Método principal para asegurar la consistencia de todos los datos
        ensureItemData(item) {
            // Asegurar consistencia de bodega
            this.ensureWarehouseData(item);
            
            // Asegurar consistencia de lote/batch
            this.ensureBatchData(item);
            
            // Asegurar consistencia de código de barras
            this.ensureBarcodeData(item);
            
            return item;
        },
        getItemFamilyId(item) {
            return item?.family ?? item?.Family ?? item?.id_family ?? item?.ID_Family ?? item?.family_id ?? null;
        },
        getItemFamilyName(item) {
            return item?.familyName ?? item?.Family ?? null;
        },
        getItemCategoryId(item) {
            return item?.category ?? item?.Category ?? item?.id_cat ?? item?.ID_Category ?? item?.category_id ?? null;
        },
        getItemCategoryName(item) {
            return item?.categoryName ?? item?.Category ?? null;
        },
        matchesSelectedFilters(item) {
            if (!item) {
                return false;
            }

            const itemFamily = this.getItemFamilyId(item);
            const itemFamilyName = this.getItemFamilyName(item);
            const itemCategory = this.getItemCategoryId(item);
            const itemCategoryName = this.getItemCategoryName(item);
            const hasFamilyMetadata = itemFamily !== null || itemFamilyName !== null;
            const hasCategoryMetadata = itemCategory !== null || itemCategoryName !== null;

            if (
                this.selectedFamily &&
                hasFamilyMetadata &&
                itemFamily != this.selectedFamily &&
                itemFamilyName != this.selectedFamilyName
            ) {
                return false;
            }

            if (
                this.selectedCategory &&
                hasCategoryMetadata &&
                itemCategory != this.selectedCategory &&
                itemCategoryName != this.selectedCategoryName
            ) {
                return false;
            }

            return true;
        },
        onDraftFamilyChange() {
            const categoryStillValid = this.draftCategoryOptions.some(
                (category) => category.value == this.draftSelectedCategory
            );

            if (!categoryStillValid) {
                this.draftSelectedCategory = null;
            }
        },
        applySegmentFilters() {
            this.selectedFamily = this.draftSelectedFamily;
            this.selectedCategory = this.draftSelectedCategory;
            this.refreshSearchResults();
        },
        getAdjustmentItemKey(item) {
            if (!item) {
                return null;
            }

            const stockSignature = item.ItemCurrentQuantity ?? item.TotalStock ?? '';
            const locationSignature = item.location_id ?? item.location ?? '';

            return [
                item.ID_Item ?? '',
                item.ID_ItemBatch ?? '',
                item.BarCode ?? item.PrincipalBarCode ?? '',
                item.Warehouse ?? this.selectedWarehouse ?? '',
                locationSignature,
                stockSignature,
            ].join('|');
        },
        async syncFilteredItemsToAdjust() {
            if (!this.selectedFamily) {
                this.filteringItemsLoading = false;
                return;
            }

            const requestSequence = ++this.filterRequestSequence;
            this.loading = true;
            this.filteringItemsLoading = true;

            let filteredItems = [];
            try {
                filteredItems = await this.$API.inventoryReports.searchInventoryItemsByFilters({
                    family: this.selectedFamily,
                    category: this.selectedCategory,
                    warehouse: this.selectedWarehouse,
                    showZeroLots: this.showZeroLots,
                });
            } catch (error) {
                console.error('Error al cargar productos por familia/categoría:', error);
                if (requestSequence === this.filterRequestSequence) {
                    this.dataToAdjust = [];
                    this.showAlert("error", "Error", "No se pudieron cargar los productos filtrados desde el servidor.");
                }
                this.loading = false;
                this.filteringItemsLoading = false;
                return;
            }

            if (requestSequence !== this.filterRequestSequence) {
                this.filteringItemsLoading = false;
                return;
            }

            const existingItemsMap = new Map(
                (this.dataToAdjust || []).map((item) => [this.getAdjustmentItemKey(item), item])
            );

            const itemsToAppend = filteredItems.reduce((acc, sourceItem) => {
                const itemToAdd = { ...sourceItem };
                const itemKey = this.getAdjustmentItemKey(itemToAdd);
                const existingItem = existingItemsMap.get(itemKey);

                if (existingItem) {
                    return acc;
                }

                itemToAdd.StockAdjustment = 0;
                itemToAdd.selectLocation = false;
                itemToAdd.checked = true;

                if (itemToAdd.ItemCurrentQuantity !== undefined && itemToAdd.ItemCurrentQuantity !== null) {
                    itemToAdd.TotalStock = itemToAdd.ItemCurrentQuantity;
                }

                this.ensureItemData(itemToAdd);
                acc.push(itemToAdd);
                return acc;
            }, []);

            this.dataToAdjust = [...this.dataToAdjust, ...itemsToAppend];
            this.loading = false;
            this.filteringItemsLoading = false;
        },
        refreshSearchResults() {
            if (this.barcodeSearch && this.barcodeSearch.trim().length >= 3) {
                this.searchByEndpoint();
            }

            this.barcodeResults = this.barcodeResults.filter((item) => this.matchesSelectedFilters(item));
            this.syncFilteredItemsToAdjust();
        },
        getInventoryLocations(warehouseId) {
            this.loading = true;
            return this.$API.inventoryReports
                .getInventoryLocations(warehouseId)
                .then((response) => response)
                .finally(() => {
                    this.loading = false;
                })
        },
        async onSelectLocationChange(isChecked, { data }) {
            //console.log(data, "onchange")
            if (isChecked) {
                this.previousLocationId = data.location_id;
                const response = await this.getInventoryLocations({ warehouseId: !this.selectedRequest ? data.Warehouse : data.ID_Warehouse });
                data.locations = response;
            } 
        },
        handleSelectLocation(locationId, locationName, data) {
            if (this.previousLocationId !== locationId) {
                data.previousLocationId = this.previousLocationId;
                data.location_id = locationId;
            }

            //data.selectLocation = false
            data.location = locationName;
            this.previousLocationId = null;
        },
        async searchByBarcode() {
            if (!this.barcodeSearch || this.barcodeSearch.trim() === '') {
                this.showAlert("warning", "Búsqueda", "Ingrese un código de barras o nombre de producto para buscar.");
                this.barcodeResults = [];
                return;
            }

            this.searchLoading = true;
            this.barcodeResults = []; // Limpiar resultados anteriores
            
            try {
                const searchTerm = this.barcodeSearch.trim();
                
                // Validar que el término de búsqueda sea válido
                if (searchTerm.length < 2) {
                    this.showAlert("warning", "Búsqueda", "Ingrese al menos 2 caracteres para buscar.");
                    return;
                }
                
                // Parámetros de búsqueda
                const searchParams = {
                    search: searchTerm,
                    limit: 10, // Limitar a 10 resultados
                    showZeroLots: this.showZeroLots, // Pasar el parámetro del checkbox
                    warehouse: this.selectedWarehouse, // Siempre incluir la bodega seleccionada
                    family: this.selectedFamilyName,
                    category: this.selectedCategoryName
                };
                
                console.log('Parámetros de búsqueda:', searchParams);
                console.log('Bodega seleccionada:', this.selectedWarehouse);
                
                // Llamar al endpoint de búsqueda
                const response = await this.$API.inventoryReports.searchInventoryItems(searchParams);
                
                // Validar la respuesta
                if (!response) {
                    this.showAlert("error", "Error", "No se pudo obtener respuesta del servidor. Verifique su conexión.");
                    this.barcodeResults = [];
                    return;
                }
                
                if (Array.isArray(response) && response.length === 0) {
                    this.showAlert("warning", "Búsqueda", `No se encontraron productos que coincidan con "${searchTerm}".`);
                    this.barcodeResults = [];
                } else if (Array.isArray(response) && response.length > 0) {
                    // Validar que los items tengan las propiedades necesarias
                    const validItems = response.filter(item => 
                        item && 
                        item.ID_Item && 
                        (item.ItemName || item.PrincipalBarCode)
                    );
                    
                    if (validItems.length === 0) {
                        this.showAlert("warning", "Búsqueda", "Los productos encontrados no tienen información válida.");
                        this.barcodeResults = [];
                    } else {
                        const filteredItems = validItems.filter((item) => this.matchesSelectedFilters(item));
                        if (filteredItems.length === 0) {
                            this.showAlert("warning", "Búsqueda", "No se encontraron productos que coincidan con la familia/categoría seleccionada.");
                            this.barcodeResults = [];
                        } else {
                            this.barcodeResults = filteredItems;
                            console.log('Items válidos encontrados:', filteredItems.length);
                        }
                    }
                } else {
                    this.showAlert("warning", "Búsqueda", "Respuesta del servidor no válida.");
                    this.barcodeResults = [];
                }
            } catch (error) {
                console.error('Error al buscar producto:', error);
                
                // Mostrar mensaje de error más específico
                let errorMessage = "Ocurrió un error al buscar el producto.";
                if (error.response) {
                    if (error.response.status === 404) {
                        errorMessage = "No se encontraron productos que coincidan con la búsqueda.";
                    } else if (error.response.status === 500) {
                        errorMessage = "Error interno del servidor. Intente nuevamente.";
                    } else {
                        errorMessage = `Error del servidor (${error.response.status}). Verifique su conexión.`;
                    }
                } else if (error.message) {
                    errorMessage = `Error de conexión: ${error.message}`;
                }
                
                this.showAlert("error", "Error", errorMessage);
                this.barcodeResults = [];
            } finally {
                this.searchLoading = false;
            }
        },
        async addItemFromBarcode(item) {
            // Verificar si el item ya está en la lista
            const duplicatedItem = this.dataToAdjust.find((el) => 
                el.ID_Item == item.ID_Item && 
                el.ID_ItemBatch == item.ID_ItemBatch && 
                el.BarCode == item.BarCode && 
                el.Warehouse == item.Warehouse
            );

            if (duplicatedItem) {
                this.showAlert("warning", "Producto duplicado", "Este producto ya está en la lista de solicitud.");
                return;
            }

            // Agregar el item a la solicitud
            const itemToAdd = { ...item };
            itemToAdd.StockAdjustment = 0;
            itemToAdd.selectLocation = false;
            itemToAdd.checked = true;
            
            // Asegurar que TotalStock tenga el valor correcto de existencias actuales
            if (itemToAdd.ItemCurrentQuantity !== undefined && itemToAdd.ItemCurrentQuantity !== null) {
                itemToAdd.TotalStock = itemToAdd.ItemCurrentQuantity;
            }
            
            // Asegurar la consistencia de todos los datos (bodega y lote)
            this.ensureItemData(itemToAdd);
            
            this.dataToAdjust.push(itemToAdd);
            
            // Si hay una solicitud activa (borrador), actualizar automáticamente
            if (this.selectedRequest || this.currentRequestId) {
                console.log('Actualizando borrador después de agregar item...');
                await this.updateDraftRequest();
            }
            
            // Limpiar búsqueda
            this.clearBarcodeSearch();
        },
        async onStockAdjustmentEdit(e) {
            console.log('Evento disparado:', e);
            console.log('dataField:', e.dataField);
            console.log('value:', e.value);
            
            // Solo proceder si se editó el campo StockAdjustment
            if (e.dataField === 'StockAdjustment' && e.value !== '' && e.value !== null && e.value !== undefined) {
                console.log('Editando StockAdjustment:', e.value);
                console.log('selectedRequest:', this.selectedRequest);
                console.log('currentRequestId:', this.currentRequestId);
                
                // Cancelar cualquier timeout de guardado previo
                if (this.saveTimeout) {
                    clearTimeout(this.saveTimeout);
                }
                
                // Debounce para evitar múltiples llamadas rápidas
                this.saveTimeout = setTimeout(async () => {
                    try {
                        // Verificar si aún estamos en un estado válido para guardar
                        if (this.isSubmittingFinalRequest || this.loading) {
                            console.log('Saltando guardado: operación en curso');
                            return;
                        }
                        
                        // Si no hay solicitud activa, crear una nueva en borrador
                        if (!this.selectedRequest && !this.currentRequestId) {
                            console.log('Creando nuevo borrador...');
                            await this.createDraftRequest();
                        } else if (this.selectedRequest || this.currentRequestId) {
                            // Si ya existe solicitud, actualizarla
                            console.log('Actualizando borrador existente...');
                            await this.updateDraftRequest();
                        }
                    } catch (error) {
                        console.error('Error durante el guardado automático:', error);
                        this.showAlert("warning", "Error", "No se pudo guardar automáticamente los cambios.");
                    }
                }, 1000); // Esperar 1 segundo después del último cambio
            } else {
                console.log('No se cumplieron las condiciones para crear/actualizar borrador');
            }
        },
        onEditorPreparing(e) {
            console.log('Editor preparando:', e);
            console.log('Column dataField:', e.dataField);
            
            if (e.dataField === 'StockAdjustment') {
                console.log('Preparando editor para StockAdjustment');
                
                // Configurar el editor para mejor manejo de números
                e.editorOptions.onValueChanged = (editorEvent) => {
                    console.log('Valor cambiado en editor:', editorEvent.value);
                    
                    // Validar que el valor sea numérico
                    if (editorEvent.value !== null && editorEvent.value !== undefined && editorEvent.value !== '') {
                        const numericValue = Number(editorEvent.value);
                        if (isNaN(numericValue)) {
                            e.editorElement.dxNumberBox("instance").option("value", '');
                            this.showAlert("warning", "Valor inválido", "Por favor ingrese un valor numérico válido.");
                            return;
                        }
                        
                        // Actualizar el valor en el modelo de datos
                        if (e.row && e.row.data) {
                            e.row.data.StockAdjustment = numericValue;
                        }
                    }
                };
                
                // Configurar el editor como NumberBox con opciones específicas
                e.editorName = "dxNumberBox";
                e.editorOptions.format = "#0.##";
                e.editorOptions.min = 0;
                e.editorOptions.showSpinButtons = true;
                e.editorOptions.placeholder = "Ingrese cantidad...";
            }
        },
        async createDraftRequest() {
            this.loading = true;
            
            // Asegurar la consistencia de todos los datos antes de crear el borrador
            this.dataToAdjust.forEach(item => {
                this.ensureItemData(item);
            });
            
            const adjustmentRequest = {
                date: this.adjustmentDate,
                data: this.dataToAdjust,
                user: JSON.parse(localStorage.getItem('user')).id,
                status: 0 // Estado borrador
            };

            try {
                const response = await this.$API.inventoryReports.createDraftRequestInventoryAdjustment(adjustmentRequest);
                
                if (response.data && response.data.ID_Request) {
                    this.selectedRequest = {
                        ID_Request: response.data.ID_Request,
                        Status: 0
                    };
                    // Marcar todos los items como guardados
                    this.dataToAdjust.forEach(item => item.isSaved = true);
                }
                this.loading = false;
            } catch (error) {
                console.log(error);
                this.loading = false;
                this.showAlert("warning", "Error", "No se pudo crear la solicitud en borrador.");
            }
        },
        async updateDraftRequest() {
            const requestId = this.selectedRequest?.ID_Request || this.currentRequestId;
            if (!requestId) {
                console.log('No hay ID de solicitud para actualizar');
                return;
            }
            
            // No actualizar si se está enviando la solicitud final o ya hay una actualización en curso
            if (this.isSubmittingFinalRequest || this.loading) {
                console.log('Saltando updateDraftRequest: operación en curso');
                return;
            }
            
            // Verificar que hay datos para actualizar
            if (!this.dataToAdjust || this.dataToAdjust.length === 0) {
                console.log('No hay datos para actualizar');
                return;
            }
            
            this.setLoadingState(true, 'Guardando cambios...');
            
            try {
                // Asegurar la consistencia de todos los datos antes de actualizar
                this.dataToAdjust.forEach(item => {
                    this.ensureItemData(item);
                });
                
                // Para borradores, simplemente eliminar todos los detalles existentes y recrear
                // Esto es más simple y evita problemas de sincronización
                const adjustmentRequest = {
                    ID_Request: requestId,
                    replaceAllData: true, // Bandera para reemplazar todos los datos
                    data: this.dataToAdjust, // Enviar todos los datos actuales
                    status: null, // Mantener estado actual
                    user: JSON.parse(localStorage.getItem('user')).id,
                };

                console.log('Enviando solicitud de actualización completa:', adjustmentRequest);

                await this.$API.inventoryReports.updateRequestInventoryAdjustment(adjustmentRequest);
                
                // Marcar todos los items como guardados después de la actualización completa
                this.dataToAdjust.forEach(item => item.isSaved = true);
                
                // Si no tenemos selectedRequest pero sí currentRequestId, crear el objeto selectedRequest
                if (!this.selectedRequest && this.currentRequestId) {
                    this.selectedRequest = {
                        ID_Request: this.currentRequestId,
                        Status: 0
                    };
                }
                
                console.log('Borrador actualizado correctamente');
            } catch (error) {
                console.error('Error al actualizar borrador:', error);
                
                // Mostrar error más específico
                let errorMessage = "No se pudo actualizar la solicitud.";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                this.showAlert("warning", "Error", errorMessage);
            } finally {
                this.setLoadingState(false);
            }
        },
        clearBarcodeSearch() {
            this.barcodeSearch = '';
            this.barcodeResults = [];
        },
        onWarehouseChange() {
            // No limpiar la búsqueda, mantener el texto
            // Si hay texto en el buscador, realizar nueva búsqueda con la nueva bodega
            if (this.barcodeSearch && this.barcodeSearch.trim().length >= 3) {
                // Ejecutar búsqueda con la nueva bodega seleccionada
                this.searchByBarcode();
            }
            this.syncFilteredItemsToAdjust();

            console.log('Cambio de bodega a:', this.selectedWarehouse);
        },
        onSearchInput() {
            // Limpiar resultados si hay menos de 3 caracteres
            if (this.barcodeSearch.length < 3) {
                this.barcodeResults = [];
                return;
            }
            
            // Búsqueda automática después de 500ms de inactividad
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(async () => {
                if (this.barcodeSearch && this.barcodeSearch.length >= 3) {
                    await this.searchByEndpoint();
                }
            }, 500);
        },
        async searchByEndpoint() {
            if (!this.barcodeSearch || this.barcodeSearch.trim() === '') {
                this.barcodeResults = [];
                return;
            }

            try {
                const searchTerm = this.barcodeSearch.trim();
                
                // Preparar parámetros de búsqueda
                const searchParams = {
                    search: searchTerm,
                    limit: 10,
                    showZeroLots: this.showZeroLots,
                    warehouse: this.selectedWarehouse, // Siempre incluir la bodega seleccionada
                    family: this.selectedFamilyName,
                    category: this.selectedCategoryName
                };
                
                // Llamar al endpoint de búsqueda sin mostrar loading para búsqueda automática
                const response = await this.$API.inventoryReports.searchInventoryItems(searchParams);
                
                this.barcodeResults = (response || []).filter((item) => this.matchesSelectedFilters(item));
            } catch (error) {
                console.error('Error en búsqueda automática:', error);
                this.barcodeResults = [];
            }
        },
        handleReset() {
            // Limpiar la solicitud activa y los datos actuales
            this.dataToAdjust = [];
            this.selectedRequest = null;
            this.adjustmentDate = null;
            this.currentRequestId = null;
            this.selectedFamily = null;
            this.selectedCategory = null;
            this.draftSelectedFamily = null;
            this.draftSelectedCategory = null;
            this.clearBarcodeSearch();
            this.quickBarcodeSearch = '';
            this.showAlert("success", "Lista limpiada", "Se ha limpiado la solicitud y todos los items.");
        },
        hasValidStockAdjustment(item) {
            return this.normalizeStockAdjustment(item.StockAdjustment) !== null;
        },
        normalizeStockAdjustment(value) {
            if (value === '' || value === null || value === undefined) {
                return 0;
            }

            const numericValue = Number(value);
            return Number.isFinite(numericValue) ? numericValue : null;
        },
        confirmFinalSubmit() {
            if (!this.dataToAdjust.length) {
                this.showAlert("warning", "Advertencia", "No existen items para enviar.");
                return;
            }

            // The grid historically rendered empty values as 0. Persist that visible value as a real number.
            this.dataToAdjust.forEach((item) => {
                item.StockAdjustment = this.normalizeStockAdjustment(item.StockAdjustment);
            });
            
            const validItems = this.dataToAdjust.filter(item => this.hasValidStockAdjustment(item));
            const invalidItems = this.dataToAdjust.filter(item => !this.hasValidStockAdjustment(item));

            if (!validItems.length) {
                this.showAlert("warning", "Datos incompletos", 
                    `Hay ${invalidItems.length} producto(s) sin cantidad de existencias físicas definida. Por favor completa todos los campos antes de enviar.`);
                return;
            }

            if (invalidItems.length > 0) {
                this.showAlert("question2", "Datos incompletos", 
                    `Se enviarán ${validItems.length} producto(s) con existencias físicas definidas y se eliminarán ${invalidItems.length} producto(s) sin completar. ¿Desea continuar?`,
                    {
                        action: "finalSubmitWithFilteredItems",
                        validItemsCount: validItems.length,
                        removedItemsCount: invalidItems.length,
                    });
                return;
            }
            
            this.showAlert("question2", "Confirmar envío", 
                `¿Está seguro que desea enviar la solicitud con ${this.dataToAdjust.length} producto(s)? Esta acción finalizará la solicitud temporal.`, 
                "finalSubmit");
        },
        
        // Método para búsqueda rápida por código de barras
        async addItemByQuickBarcode() {
            if (!this.quickBarcodeSearch || this.quickBarcodeSearch.trim() === '') {
                this.showAlert("warning", "Código requerido", "Ingrese un código de barras para buscar.");
                return;
            }

            this.quickSearchLoading = true;
            
            const barcode = this.quickBarcodeSearch.trim();
            
            // Parámetros de búsqueda exacta por código de barras
            const searchParams = {
                barcode: barcode, // Búsqueda exacta por código de barras
                showZeroLots: this.showZeroLots,
                warehouse: this.selectedWarehouse,
                family: this.selectedFamilyName,
                category: this.selectedCategoryName
            };
            
            console.log('Búsqueda exacta por código de barras:', searchParams);
            
            try {
                // Llamar al endpoint específico para búsqueda exacta por código de barras
                const response = await this.$API.inventoryReports.searchInventoryItemsByBarcode(searchParams);
                // Desactivar loading inmediatamente después de recibir respuesta
                this.quickSearchLoading = false;
                
                if (!response || response.length === 0) {
                    this.showAlert("warning", "No encontrado", `No se encontró ningún producto con el código de barras exacto "${barcode}".`);
                    this.quickBarcodeSearch = ''; // Limpiar el campo aunque no se encuentre
                    return;
                }
                
                const filteredResponse = response.filter((item) => this.matchesSelectedFilters(item));
                if (filteredResponse.length === 0) {
                    this.showAlert("warning", "No coincide con filtros", "El producto encontrado no pertenece a la familia/categoría seleccionada.");
                    this.quickBarcodeSearch = '';
                    return;
                }

                // Tomar el primer resultado
                const item = filteredResponse[0];
                
                // Verificar si el item ya está en la lista
                const duplicatedItem = this.dataToAdjust.find((el) => 
                    el.ID_Item == item.ID_Item && 
                    el.ID_ItemBatch == item.ID_ItemBatch && 
                    el.BarCode == item.BarCode && 
                    el.Warehouse == item.Warehouse
                );

                if (duplicatedItem) {
                    this.showAlert("warning", "Producto duplicado", `El producto "${item.ItemName}" ya está en la lista de solicitud.`);
                    this.quickBarcodeSearch = ''; // Limpiar el campo
                    return;
                }

                // Agregar el item a la solicitud
                const itemToAdd = { ...item };
            itemToAdd.StockAdjustment = 0;
                itemToAdd.selectLocation = false;
                itemToAdd.checked = true;
                
                // Asegurar que TotalStock tenga el valor correcto de existencias actuales
                if (itemToAdd.ItemCurrentQuantity !== undefined && itemToAdd.ItemCurrentQuantity !== null) {
                    itemToAdd.TotalStock = itemToAdd.ItemCurrentQuantity;
                }

                // Asegurar la consistencia de todos los datos
                this.ensureItemData(itemToAdd);
                
                this.dataToAdjust.push(itemToAdd);
                
                // Si hay una solicitud activa (borrador), actualizar automáticamente
                if (this.selectedRequest || this.currentRequestId) {
                    console.log('Actualizando borrador después de agregar item rápido...');
                    await this.updateDraftRequest();
                }
                
                // Mostrar mensaje de éxito y limpiar campo
                this.showAlert("success", "Producto agregado", `Se agregó "${item.ItemName}" a la solicitud.`);
                this.quickBarcodeSearch = '';
                
            } catch (error) {
                // Desactivar loading en caso de error
                this.quickSearchLoading = false;
                
                console.error('Error en búsqueda rápida:', error);
                this.showAlert("error", "Error", "Ocurrió un error al buscar el producto. Verifique su conexión.");
                this.quickBarcodeSearch = ''; // Limpiar también en caso de error
            }
        },
        
        // Método para manejar input en búsqueda rápida
        onQuickBarcodeInput() {
            // Limpiar timeout anterior
            clearTimeout(this.quickSearchTimeout);
            
            // Si el campo está vacío, no hacer nada
            if (!this.quickBarcodeSearch || this.quickBarcodeSearch.trim() === '') {
                return;
            }
            
            // Si es un código completo (generalmente 13 dígitos o más), buscar automáticamente
            if (this.quickBarcodeSearch.length >= 8) {
                this.quickSearchTimeout = setTimeout(() => {
                    this.addItemByQuickBarcode();
                }, 500); // Esperar 500ms después de dejar de escribir
            }
        }
       
    },
    async mounted() {
        this.assignParams();
        await this.loadWarehouses();
        this.getEarningDetail();
        this.getAdjustmentRequest();
    },
    beforeDestroy() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }
        if (this.quickSearchTimeout) {
            clearTimeout(this.quickSearchTimeout);
        }
    },
};
</script>

<style scoped>
.tabsNH {
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;
    margin-top: 1rem;
    border-radius: 10px;
}

.btnblack {
    background-color: rgba(60, 60, 60, 1) !important;
    color: white !important;
}

.segment-filter-label {
    font-size: 0.95rem;
    font-weight: 600;
    color: #1976d2;
}

.segment-apply-btn {
    min-width: 60px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.close-btn {
    color: white !important;
    position: relative !important;
    float: right !important;
}

.border {
  border-radius: 15px !important;
}

/* Estilos para la columna de existencias físicas editable */
.editable-stock-column {
  background-color: #e3f2fd !important;
  border-left: 3px solid #2196f3 !important;
}

.dx-datagrid .dx-data-row .dx-editor-cell {
  background-color: #fff3e0 !important;
  border: 2px solid #ff9800 !important;
  border-radius: 4px !important;
}

.dx-datagrid .dx-data-row .dx-editor-cell .dx-texteditor {
  background-color: #fff3e0 !important;
}

.dx-datagrid .dx-data-row .dx-editor-cell .dx-texteditor-input {
  background-color: #fff3e0 !important;
  font-weight: bold !important;
  color: #e65100 !important;
}

/* Hover effect para las celdas editables */
.dx-datagrid .dx-data-row td[aria-describedby*="StockAdjustment"]:hover {
  background-color: #ffecb3 !important;
  cursor: pointer !important;
  border: 1px solid #ffa000 !important;
  transition: all 0.3s ease !important;
}

/* Estilo para las celdas editables cuando no están en modo edición */
.dx-datagrid .dx-data-row td[aria-describedby*="StockAdjustment"] {
  background-color: #f3e5f5 !important;
  border-left: 3px solid #9c27b0 !important;
  font-weight: 600 !important;
  color: #4a148c !important;
}

.barcode-result-item:hover {
  background-color: #f5f5f5 !important;
}

.barcode-result-item {
  transition: background-color 0.2s ease;
}

.barcode-result-item .v-list-item__subtitle {
  font-size: 0.85em;
  line-height: 1.3;
}

/* Estilos para el template personalizado de celdas editables - Diseño corporativo */
.editable-stock-cell-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 4px;
  border: 1px solid #dee2e6;
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.editable-stock-cell-wrapper:hover {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  border-color: #1976d2;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(25, 118, 210, 0.15);
}

.editable-stock-cell-wrapper .edit-icon {
  color: #6c757d;
  transition: color 0.25s ease;
}

.editable-stock-cell-wrapper:hover .edit-icon {
  color: #1976d2;
  animation: none;
}

.editable-stock-cell-wrapper .stock-value {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  min-width: 35px;
  text-align: center;
  margin-right: 4px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.editable-stock-cell-wrapper .edit-hint {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  color: #6c757d;
  background: rgba(255, 255, 255, 0.95);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.25s ease;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.editable-stock-cell-wrapper:hover .edit-hint {
  opacity: 1;
}

.scrollable-text {
  overflow-x: auto;
  white-space: nowrap;
  max-width: 400px;
  display: block;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.scrollable-text::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Opera */
}
</style>
